import React from 'react';
import {
    inject,
    observer
} from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Button } from 'oned';
import './index.less';
import { HomeBusiness } from '@business/newCreateRequest/common/home';
import { StepType } from '@common/enums/base';
var HomeBanner = inject(HomeBusiness)(observer(function (props) {
    var jump = props.jump, initProblem = props.initProblem, currentUser = props.currentUser, getGreetingText = props.getGreetingText, history = props.history;
    var toCreateEntrance = function () {
        history.push('/newRequest/create');
        jump(StepType.Problem);
        initProblem();
    };
    var getFirstName = function (fullName) {
        if (!fullName)
            return;
        var space = fullName.indexOf(' ');
        var firstName = fullName.substring(0, space);
        return firstName;
    };
    return React.createElement('div', { className: 'rsp-banner' }, React.createElement('div', { className: 'rsp-body' }, React.createElement('div', { className: 'banner-container' }, React.createElement('div', { className: 'r-greetings' }, React.createElement('div', { className: 'r-greetings-info' }, React.createElement('h1', null, getGreetingText, ' ', React.createElement('span', null, getFirstName(currentUser.fullName)))), React.createElement('img', {
        src: 'https://rsp-front-end-stage.lessen.com/sources/svg/banner.svg',
        className: 'r-greetings-img'
    })), React.createElement('div', { className: 'r-entrence' }, React.createElement('div', { className: 'entrence-info' }, React.createElement('div', { className: 'entrence-info-align' }, React.createElement('img', { src: 'https://rsp-front-end-stage.lessen.com/sources/svg/banner-icon.svg' }), React.createElement('h4', null, 'Do you have a maintenance issue?'), React.createElement('div', null, 'Submit your request with the button below'))), React.createElement('div', { className: 'btn-box' }, React.createElement(Button, {
        type: 'primary',
        onClick: function () {
            return toCreateEntrance();
        }
    }, 'Request maintenance'))))));
}));
export default withRouter(HomeBanner);